import * as React from 'react';
import * as styles from './Aside.css';

export interface IAsideProps {
  children: React.ReactNode;
}

export function Aside({ children }: IAsideProps) {
  return <div className={styles['container']}>{children}</div>;
}
